export const openAccountMembersListPage = () => {
  window.open(`/account_members`, '_blank')
}
